import { AreaOfInterestType, ProcedureType } from "api/type";

export const isAISupportedProcedure = (procedure: ProcedureType) => {
  return [
    ProcedureType.BREAST_AUGMENTATION,
    ProcedureType.BREAST_LIFT,
    ProcedureType.BREAST_REDUCTION,
    ProcedureType.BREAST_LIFT_AND_AUGMENTATION,
    ProcedureType.BBL,
    ProcedureType.TUMMY_TUCK,
    ProcedureType.LIP_FILLER,
    ProcedureType.BUTTOCK_AUGMENTATION,
  ].includes(procedure);
};

export const isAISupportedArea = (area: AreaOfInterestType) => {
  return [
    AreaOfInterestType.BREAST,
    AreaOfInterestType.TORSO,
    AreaOfInterestType.BUTT,
    AreaOfInterestType.FACE,
  ].includes(area);
};
